<template>
  <div
    class="lesson-item"
    :style="courseBorderColor"
  >
    <section class="lesson-item__title">
      <strong class="title">{{ data.name }}</strong>
      <div class="controller">
        <span @click="handleClickEdit">기본 설정 수정</span>
        <div class="vr">
          |
        </div>
        <span @click="handleClickDelete">삭제</span>
      </div>
    </section>
    <section class="description">
      <span>{{ data.duration }}분</span>
      <div class="vr">
        |
      </div>
      <span>{{ data.instructorNames }}</span>
    </section>
  </div>
</template>

<script>
export default {
	name: "CourseItem",
	props: ["data"],
	computed: {
		courseBorderColor() {
			return {
				borderLeft: `7px solid ${this.data.color}`,
			};
		},
	},
	methods: {
		handleClickEdit() {
			this.$emit("modify", this.data);
		},
		handleClickDelete() {
			this.$emit("delete", this.data);
		},
	},
};
</script>

<style lang="scss">
.lesson-item {
	background-color: #f2f2f2;
	border-radius: 6px;
	border: 1px solid #d3d3d3;
	border-left: 7px solid #224ba2;
	padding: 17px 13px 14px;
	position: relative;
	box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.19);
	margin-bottom: 10px;
	.lesson-item__title{
		display: flex;
		.title {
			width: calc(100% - 106px);
			font-size: 16px;
			color: #4a4a4a;
			letter-spacing: -0.8px;
			font-weight: 500;
			line-height: 20px;
			margin-bottom: 6px;
			margin-right: 6px;
		}

		.controller {
			width: 100px;
			font-size: 12px;
			letter-spacing: -0.8px;
			color: #d3d3d3;

			& > span {
				color: #9b9b9b;

				&:hover {
					text-decoration: underline;
					cursor: pointer;
				}
			}
		}
	}

	.description {
		color: #d3d3d3;
		font-weight: 200;

		& > span {
			font-size: 14px;
			color: #4a4a4a;
			letter-spacing: -0.8px;
			line-height: 20px;
		}
	}
}
</style>
